import ArrowDown from "../ArrowDown";
import CssLayers from "../CssLayers";
import PropTypes from "prop-types";
import React from "react";
import testId from "../testId";

export default function EditorInlineTooltip({ position, visible, innerRef, children }) {
  return (
    <div
      {...testId("EditorInlineTooltip/rootContainer")}
      ref={innerRef}
      style={position}
      css={{
        position: "absolute",
        visibility: visible ? "visible" : "hidden",
        transform: `translate(-50%) scale(${visible ? 1 : 0})`,
        zIndex: CssLayers.INLINE_TOOLBAR,
      }}
    >
      <div
        css={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div
          {...testId("EditorInlineTooltip/tray")}
          css={{
            position: "relative",
            color: "#ffffff",
            backgroundColor: "#212121",
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
          }}
        >
          {children}
        </div>

        <ArrowDown width="6px" backgroundColor="#212121" />
      </div>
    </div>
  );
}

EditorInlineTooltip.propTypes = {
  position: PropTypes.shape({
    top: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
  }),
  visible: PropTypes.bool.isRequired,
  innerRef: PropTypes.func.isRequired,
  children: PropTypes.any.isRequired,
};

EditorInlineTooltip.defaultProps = {
  position: null,
};
